module.exports = {"name":"Image widget SZTS","icon":"<i class='material-icons'>photo_library</i>","widget":[{"type":"image-for-image-widget-szts","initData":{"img":"https://placehold.it/420x600"},"width":420,"height":600},{"type":"image-for-image-widget-szts","initData":{"img":"https://placehold.it/420x600"},"width":420,"height":600},{"type":"image-for-image-widget-szts","initData":{"img":"https://placehold.it/420x600"},"width":420,"height":600}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/image-widget-szts/image-widget-szts.json
// module id = 351
// module chunks = 0